export default __webpack_public_path__ + "static/media/111t.cfbe76f9.jpg";